import { useFormContext, useWatch } from 'react-hook-form'
import { Stack } from '@mui/material'
import { TagsField } from '@ui2/forms'
import { TextField } from '@ui/forms'
import useSaveShortcut from '../../hooks/useSaveShortcut'

interface Props {
  onSubmit: (data: unknown) => void
}

const FormFields = ({ onSubmit }: Props) => {
  const { setValue } = useFormContext()
  const tags: string[] = useWatch({ name: 'tags' }) ?? []

  useSaveShortcut(onSubmit)

  return (
    <Stack spacing={1}>
      <TagsField
        value={tags}
        onChange={nextTags => setValue('tags', nextTags, { shouldDirty: true })}
      />

      <TextField label="Name" name="node_name" fullWidth placeholder="Name" />
      <TextField
        label="Kommentar"
        name="comment"
        multiline
        rows={3}
        fullWidth
        placeholder="Kommentar"
      />
    </Stack>
  )
}

export default FormFields
